import { useQueryClient } from '@tanstack/react-query';
import React from 'react';

import { useSocketStore } from '../../store/useSocketStore';
import { queryKeys } from '../../queryKeys';

export function useScheduleNoteSocket() {
  const { socket } = useSocketStore();
  const queryClient = useQueryClient();

  React.useEffect(() => {
    if (!socket) return;

    const invalidateScheduleNotes = () => {
      queryClient.invalidateQueries({
        exact: false,
        queryKey: queryKeys.scheduleNote.fetchScheduleNotes._def,
      });
    };

    socket.on('schedule-note:added', invalidateScheduleNotes);

    return () => {
      socket.off('schedule-note:added', invalidateScheduleNotes);
    };
  }, [socket, queryClient]);
}
